
import { AppContext } from "context/AppContext";
import style from "./ConfirmModal.module.css";
import { useContext } from "react";

// isConfirmOpen, setIsConfirmOpen



export default function ConfirmModal  ({ title, message, onConfirm }){
  const {isConfirmOpen, setIsConfirmOpen} = useContext(AppContext);

    if(isConfirmOpen) {
         return (
    <div className={style.modalOverlay}>
      <div className={style.modalBox}>
        <h3>{title}</h3>
        <p>{message}</p>
        <div className={style.modalActions}>
          <button className={style.btnCancel} onClick={()=>{setIsConfirmOpen(false)}}>
            Anuluj
          </button>
          <button className={style.btnConfirm} onClick={()=>{
            onConfirm()
            setIsConfirmOpen(false);
          }}>
            OK
          </button>
        </div>
      </div>
    </div>
  ); 
    }

};

